// extracted by css-extract-rspack-plugin
export default {"root":"root-1VBdU","icon":"icon-2XDLj","default":"default-sVSUq","success":"success-3JIhN","warning":"warning-32YDu","error":"error-oqLbt","info":"info-288Ga"};